export default __webpack_public_path__ + "static/media/signatureIcon.f1c01a5a.svg";